import React, { useState } from "react";
import targets from "../data/targets.json";

/** The context.
 */
export const TargetsContext = React.createContext(null);

/** The Context Provider.
 *
 *  @param {} props
 */
export const TargetsContextProvider = (props) => {
  const [state] = useState(targets);

  // Render.
  return <TargetsContext.Provider value={state}>{props.children}</TargetsContext.Provider>;
};
